import styled, { css } from 'styled-components/macro'

export const StyledComponentBuilder = styled.div`
    opacity: 1;
    transition: opacity ${({ theme }) => theme.defaults.baseTransition};

    ${({ hide }) => hide && css`opacity: 0;`}
`
